export default "__VITE_ASSET__7ixiydoz__"